import { render, staticRenderFns } from "./ServiceProviderPrice.vue?vue&type=template&id=0386445f&scoped=true"
import script from "./ServiceProviderPrice.vue?vue&type=script&lang=js"
export * from "./ServiceProviderPrice.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderPrice.vue?vue&type=style&index=0&id=0386445f&prod&scoped=true&lang=scss"
import style1 from "./ServiceProviderPrice.vue?vue&type=style&index=1&id=0386445f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386445f",
  null
  
)

export default component.exports